import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { FormControl, InputLabel } from '@mui/material'

interface Props {
  name: string
  value?: string
  disabled?: boolean
  register: (instance: any) => void
  height: number
  label: JSX.Element | string
  maxLength?: number
  maxCharactersSoftLimit?: number
  required?: boolean
}

export default function TextArea({
  name,
  value,
  disabled = false,
  register,
  height,
  label,
  maxLength,
  maxCharactersSoftLimit,
  required = false,
}: Props): JSX.Element {
  const intl = useIntl()

  return (
    <>
      <InputContainer margin="normal" fullWidth required={required}>
        <FieldLabel>
          {label}
          {maxCharactersSoftLimit &&
            ` (${intl.formatMessage({ id: 'strings.maxCharacters' })} ${maxCharactersSoftLimit})`}
        </FieldLabel>
        <textarea
          name={name}
          {...(register ? register(name) : {})}
          style={{ height: `${height}px` }}
          disabled={disabled}
          maxLength={maxLength}
          defaultValue={value}
          required={required}
          placeholder={required ? intl.formatMessage({ id: 'strings.required' }) : ''}
        />
        {maxCharactersSoftLimit && value && (
          <MaxCharacters>
            {value.length > maxCharactersSoftLimit ? (
              <OverLimit>
                {value.length}/{maxCharactersSoftLimit}
              </OverLimit>
            ) : (
              <InsideLimit>
                {value.length}/{maxCharactersSoftLimit}
              </InsideLimit>
            )}
          </MaxCharacters>
        )}
      </InputContainer>
    </>
  )
}

const InputContainer = styled(FormControl)`
  margin: 20px 0;

  & textarea {
    border: 1px solid;
    border-color: ${(props) => props.theme.customPalette.mediumGray};
    border-radius: 5px;
    color: ${(props) => props.theme.customPalette.darkGray};
    padding: 20px;
  }
`

const FieldLabel = styled(InputLabel)`
  padding: 0 10px;
  margin-top: -20px;
  transition: none;
  transform: none;
`

const MaxCharacters = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 5px;
  font-size: 0.8em;
`

const OverLimit = styled.span`
  color: ${(props) => props.theme.customPalette.error};
`

const InsideLimit = styled.span`
  color: ${(props) => props.theme.palette.primary.main};
`
